<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="row">
              <div class="col-1">
                <router-link
                  class="btn btn-sm btn-outline-info"
                  :to="{ name: 'cat-escalas' }"
                >
                  <i class="fas fa-angle-double-left"></i>
                  Atras
                </router-link>
              </div>
              <div class="col-11">
                <div class="os-tabs-w">
                  <div class="os-tabs-controls os-tabs-complex text-right">
                    <ul class="nav nav-tabs">
                      <li class="nav-item">
                        <span aria-expanded="true" class="nav-link active"
                          ><small class="tab-value">FECHA DE CREACIÓN:</small
                          ><span class="tab-label" style="font-size: 18px">{{
                            current.fecha_creacion
                          }}</span></span
                        >
                      </li>
                      <li class="nav-item">
                        <span aria-expanded="true" class="nav-link active"
                          ><small class="tab-value">USUARIO:</small
                          ><span class="tab-label" style="font-size: 18px">{{
                            current.usuario
                          }}</span></span
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div
                  class="element-box"
                  style="
                    padding: 0.8rem;
                    margin-top: 0rem;
                    margin-bottom: 0.5rem;
                  "
                >
                  <h5 class="form-header">
                    <span v-if="current && current.id"
                      >Información de la campaña</span
                    >
                    <span v-if="!current.id">Nueva campaña</span>
                    <u>{{ current.numero }}</u>
                    &nbsp;
                    <span
                      v-if="current.fecha_inicio > fecha_actual"
                      class="badge badge-info"
                      >Campaña de oferta no ha entrado en vigencia</span
                    >
                    <span
                      v-if="
                        current.fecha_inicio <= fecha_actual &&
                        current.fecha_fin >= fecha_actual
                      "
                      class="badge badge-success"
                      >Campaña de oferta activa</span
                    >
                    <span
                      v-if="
                        current.fecha_fin && current.fecha_fin < fecha_actual
                      "
                      class="badge badge-danger"
                      >Campaña de oferta ha vencido</span
                    >
                  </h5>
                </div>
              </div>
              <div class="col-8" style="padding-right: 0px">
                <div
                  class="element-box"
                  style="padding: 1rem; margin-top: 0rem"
                >
                  <small
                    v-if="current.errors && current.errors.detail"
                    class="form-text text-danger"
                    >{{ current.errors.detail }}</small
                  >
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors && current.errors.nombre,
                          }"
                          >Nombre Escala</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-model="current.nombre"
                        />
                        <small
                          v-if="current.errors && current.errors.nombre"
                          class="form-text text-danger"
                          >{{ current.errors.nombre[0] }}</small
                        >
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors && current.errors.fecha_inicio,
                          }"
                          >Fecha Inicio</label
                        >
                        <input
                          type="date"
                          class="form-control"
                          v-model="current.fecha_inicio"
                        />
                        <small
                          v-if="current.errors && current.errors.fecha_inicio"
                          class="form-text text-danger"
                          >{{ current.errors.fecha_inicio[0] }}</small
                        >
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors && current.errors.fecha_fin,
                          }"
                          >Fecha Fín</label
                        >
                        <input
                          type="date"
                          class="form-control"
                          v-model="current.fecha_fin"
                        />
                        <small
                          v-if="current.errors && current.errors.fecha_fin"
                          class="form-text text-danger"
                          >{{ current.errors.fecha_fin[0] }}</small
                        >
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors && current.errors.tipo_oferta,
                          }"
                          >Tipo</label
                        >
                        <select
                          class="form-control"
                          autofocus="autofocus"
                          v-model="current.tipo_oferta"
                          :disabled="current.estado == 'B'"
                        >
                          <option value="E">Escala</option>
                          <option value="B">Bonificación</option>
                        </select>
                        <small
                          v-if="current.errors && current.errors.tipo_oferta"
                          class="form-text text-danger"
                          >{{ current.errors.tipo_oferta[0] }}</small
                        >
                      </div>
                    </div>
                  </div>
                  <button
                    v-if="!current.id"
                    @click="guardar()"
                    class="btn btn-success"
                  >
                    Guardar
                  </button>
                </div>
                <div
                  class="element-box"
                  style="padding: 1rem; margin-top: 0rem"
                  v-if="current && current.id"
                >
                  <div class="row">
                    <div class="col-12">
                      <ProductoSelectComponentV2 :current="currentDetalle" />
                    </div>
                    <div class="col-4">
                      <UnidadMedidaSelectComponent :current="currentDetalle" />
                    </div>
                    <div class="col-4">
                      <label
                        v-bind:class="{
                          'text-danger':
                            currentDetalle.errors.unidad_medida &&
                            currentDetalle.errors.unidad_medida.length > 0,
                        }"
                        >Precio</label
                      >
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="currentDetalle.precio"
                      />
                      <small
                        v-if="currentDetalle && currentDetalle.errors"
                        class="text-danger"
                        >{{ currentDetalle.errors.precio }}</small
                      >
                    </div>
                    <div class="col-4">
                      <label>Cantidad Minima</label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="currentDetalle.cantidad_minima"
                      />
                      <small
                        v-if="currentDetalle && currentDetalle.errors"
                        class="text-danger"
                        >{{ currentDetalle.errors.cantidad_minima }}</small
                      >
                    </div>
                    <br />
                    <button
                      type="button"
                      class="btn btn-sm btn-dark btn-block"
                      @click="agregaDetalle()"
                    >
                      <i class="fa fa-plus"></i>
                      Agregar Producto
                    </button>
                    <div class="table-responsive" v-if="current.id != null">
                      <br />
                      <table class="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>Producto</th>
                            <th class="text-center">UM</th>
                            <th class="text-center">Cantidad</th>
                            <th class="text-center">Precio</th>
                            <th class="text-center">Opciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="detalle in current.campanadeofertasproducto_set"
                            v-bind:key="detalle.id"
                          >
                            <td>
                              {{ detalle.producto.sku }} -{{
                                detalle.producto.nombre
                              }}
                            </td>
                            <td>
                              {{ detalle.unidad_medida.nombre }}
                            </td>

                            <td>
                              <span class="text-success">
                                {{ detalle.cantidad_minima }}</span
                              >
                            </td>

                            <td>
                              <span class="text-success">
                                {{ detalle.precio }}</span
                              >
                            </td>
                            <td class="text-center">
                              <button
                                class="btn btn-sm btn-danger mr-1"
                                type="button"
                                @click="deleteDetalle(detalle)"
                              >
                                <i class="fa fa-trash"></i>
                                Eliminar
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-------------------- END - Basic Table -------------------->
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="element-box">
                  <br />
                  <div class="row">
                    <table
                      v-if="current && current.id"
                      class="table table-bordered"
                    >
                      <thead>
                        <th class="text-center">Tienda</th>
                        <th class="text-center">
                          <br />
                          <label for="multiple">Seleccion Multiple </label>
                          &nbsp;
                          <input
                            type="checkbox"
                            id="multiple"
                            class="form-control"
                            v-model="all_tiendas"
                            @change="agregarTodosTiendas()"
                          />
                        </th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Seleccion Multiple</td>

                          <td class="text-center">
                            <input
                              type="checkbox"
                              class="form-control"
                              v-model="all_tiendas"
                              @change="agregarTodosTiendas()"
                            />
                          </td>
                        </tr>
                        <tr
                          v-for="det in current.tiendas_set"
                          :key="det.id"
                          :value="det.id"
                        >
                          <td>{{ det.nombre }}</td>
                          <td class="text-center">
                            <input
                              type="checkbox"
                              class="form-control"
                              @change="agregarDetalleTienda(det)"
                              v-model="det.seleccionada"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import ReqTrasladoService from "@/services/inventario/ReqTrasladoService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import UnidadMedidaSelectComponent from "@/components/commons/UnidadMedidaSelectComponent";
import ProductoWithPopoverComponent from "@/components/commons/ProductoWithPopoverComponent";
import DynamicService from "@/services/commons/DynamicService";
import SalidaTrasladoService from "@/services/inventario/SalidaTrasladoService";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";

export default {
  components: {
    TiendaSelectComponent,
    UnidadMedidaSelectComponent,
    ProductoWithPopoverComponent,
    ProductoSelectComponentV2,
  },
  data() {
    return {
      current: {
        fecha_creacion: "",
        fecha_fin: "",
        tipo: "-",
        errors: {
          tienda: "",
          fecha: "",
        },
        reqtrasladod_set: [],
      },
      fecha_actual: "",
      all_tiendas: "",
      unidades_medidas: [],
      productos: [],
      options: [],

      currentDetalle: {
        precio: 0,
        cantidad_minima: 0,
        unidad_medida: "",
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.fecha_actual = res.data.fecha_actual;
      self.fecha_actual = moment(self.fecha_actual, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      );
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    agregarDetalleTienda(item) {
      let self = this;
      DynamicService.postAction(
        "cat",
        "campana-ofertas",
        self.current.id,
        "agregar_tienda",
        {
          tienda: item.codigo,
        }
      )
        .then((response) => {
          Notifications.toast.success(
            "Agregar o quitar tienda",
            "Se ha guardado la Información."
          );
          self.validacion();
        })
        .catch((error) => {
          self.currentDetalle.errors = error.response.data;
          console.log(error.response.data);
          if (error.response.data.detail) {
            Notifications.alert.error(
              "Agregar o quitar tienda",
              error.response.data.detail
            );
            self.refreshCurrent();
          }
        });
    },
    agregarTodosTiendas() {
      let self = this;
      DynamicService.getAction(
        "cat",
        "campana-ofertas",
        self.current.id,
        "agregar_tienda_lista",
        {
          status: self.all_tiendas,
        }
      )
        .then((response) => {
          Notifications.toast.success(
            "Agregar o quitar todas las tiendas tienda",
            "Se ha guardado la Información."
          );
          self.refreshCurrent();
        })
        .catch((error) => {
          self.currentDetalle.errors = error.response.data;
          console.log(error.response.data);
          if (error.response.data.detail) {
            Notifications.alert.error(
              "Agregar o quitar todas las tiendas",
              error.response.data.detail
            );
            self.refreshCurrent();
          }
        });
    },
    refreshDefault() {
      let self = this;
      self.currentDetalle.cantidad = 0;
      self.currentDetalle.precio = 0;
      self.currentDetalle.cantidad_minima = "";
      self.currentDetalle.unidad_medida = "";
      self.currentDetalle.producto = "";
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById(
        "cat",
        "campana-ofertas",
        this.$route.params.id
      ).then((response) => {
        self.current = response.data;
        self.current.usuario = response.data.usuario.name;
        self.current.fecha_fin = moment(
          response.data.fecha_fin,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD");
        self.current.fecha_inicio = moment(
          response.data.fecha_inicio,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD");
        self.current.fecha_creacion = moment(
          self.current.fecha_creacion
        ).format("DD/MM/YYYY hh:mm:s a");
        self.current.errors = [];
        self.validacion();
      });
    },
    validacion() {
      let self = this;
      let d = self.current.tiendas_set.filter(function (det) {
        return det.seleccionada == true;
      });
      if (d[0]) {
        self.all_tiendas = true;
      } else {
        self.all_tiendas = false;
      }
    },
    guardar() {
      let self = this;
      let current = Object.assign({}, self.current);
      current.tienda = self.current.tienda;
      if (self.current.fecha_inicio) {
        current.fecha_inicio = moment(self.current.fecha_inicio).format(
          "DD/MM/YYYY"
        );
      }
      if (self.current.fecha_fin) {
        current.fecha_fin = moment(self.current.fecha_fin).format("DD/MM/YYYY");
      }
      DynamicService.save("cat", "campana-ofertas", current)
        .then((response) => {
          Notifications.alert.success(
            "Guardar campaña de ofertas",
            "Realizádo Exitosamente"
          );
          if (current.id == null) {
            self.$router.push({
              name: "cat-escalas-editar",
              params: { id: response.data.id },
            });
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
          Notifications.alert.error(
            "Guardar campañas de ofertas",
            error.response.data.detail
          );
        });
    },
    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (det.producto) {
        det.producto = det.producto.sku;
        det.unidad_medida = self.currentDetalle.unidad_medida;
        DynamicService.postAction(
          "cat",
          "campana-ofertas",
          self.current.id,
          "agregar_producto",
          det
        )
          .then((response) => {
            Notifications.alert.success(
              "Agregar producto",
              "Se ha guardado la Información."
            );
            self.refreshCurrent();
            self.refreshDefault();
          })
          .catch((error) => {
            self.currentDetalle.errors = error.response.data;
            console.log(error.response.data);
            if (error.response.data.detail) {
              Notifications.alert.error(
                "Agregar producto",
                error.response.data.detail
              );
            }
          });
      }
    },
    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar producto",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          DynamicService.postAction(
            "cat",
            "campana-ofertas",
            self.current.id,
            "eliminar_linea",
            {
              id: detalle.id,
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Eliminar producto",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Eliminar producto",
                  error.response.data.detail
                );
              }
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Requerimiento de Traslado",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          ReqTrasladoService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Traslado",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.salida_traslado_d
                );
              }
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "¡Información Importante!",
        "Si cierra la requisicion no podra abrirla nuevamente",
        "Si cerrar",
        function () {
          ReqTrasladoService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Traslado",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Requerimiento de Traslado",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          ReqTrasladoService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Traslado",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.salida_traslado_d
                );
              }
            });
        }
      );
    },
  },
};
</script>
